"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Content = exports.Underline = exports.Spacer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../../helpers");

var _Link = _interopRequireDefault(require("../../typography/Link"));

var _IconContainer = _interopRequireDefault(require("../../IconContainer"));

var _Chip = _interopRequireDefault(require("../../typography/Chip"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Spacer = _styledComponents.default.div.withConfig({
  displayName: "Spacer",
  componentId: "sc-1pt5s69-0"
})(["width:8px;"]);

exports.Spacer = Spacer;

var Underline = _styledComponents.default.div.withConfig({
  displayName: "Underline",
  componentId: "sc-1pt5s69-1"
})(["border-bottom:2px solid white;width:100%;display:none;margin-top:10px;"]);

exports.Underline = Underline;

var Content = _styledComponents.default.div.withConfig({
  displayName: "Content",
  componentId: "sc-1pt5s69-2"
})(["display:inline-flex;padding:0 8px;pointer-events:none;"]);

exports.Content = Content;
var StyledIconContainer = (0, _styledComponents.default)(_IconContainer.default).withConfig({
  displayName: "StyledIconContainer",
  componentId: "sc-1pt5s69-3"
})(["", ""], function (p) {
  return p.hasText && "\n        width: 24px;\n        height: 24px;\n  ";
});

var Component = function Component(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Icon = _ref.icon,
      _ref$link = _ref.link,
      Link = _ref$link === void 0 ? _Link.default : _ref$link,
      to = _ref.to,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["children", "className", "icon", "link", "to", "onClick"]);

  return _react.default.createElement(Link, _extends({
    to: to,
    onClick: onClick,
    className: "menuItem ".concat(className)
  }, props), _react.default.createElement(Content, null, Icon && _react.default.createElement(StyledIconContainer, {
    hasText: !!children
  }, _react.default.createElement(Icon, null)), Icon && children && _react.default.createElement(Spacer, null), children), _react.default.createElement(Underline, null));
};

var BaseComponent = (0, _styledComponents.default)(Component).withConfig({
  displayName: "BaseComponent",
  componentId: "sc-1pt5s69-4"
})(["&&{display:flex;flex-direction:column;vertical-align:middle;height:3.75rem;font-size:1rem;font-weight:", ";line-height:1.5rem;text-decoration:none;background:", ";padding:16px 8px 0;border-style:solid;border-width:0;color:", ";transition:none;}", "{margin-left:8px;}"], (0, _helpers.fontWeight)('regular'), (0, _helpers.color)('brand'), (0, _helpers.color)('white'), _Chip.default);
var DefaultMenuItem = (0, _styledComponents.default)(BaseComponent).withConfig({
  displayName: "DefaultMenuItem",
  componentId: "sc-1pt5s69-5"
})(["&&{color:", ";opacity:0.6;}&&:focus{color:", ";opacity:1;}&&:hover{background:", ";border-bottom:0;color:", ";cursor:pointer;opacity:1;}&&:active{background:", ";border-bottom:0;border-top-color:", ";color:", ";opacity:1;}"], (0, _helpers.color)('white'), (0, _helpers.color)('white'), (0, _helpers.color)('accent-4'), (0, _helpers.color)('white'), (0, _helpers.color)('brand'), (0, _helpers.color)('neutral-2'), (0, _helpers.color)('white'));
var currentCss = (0, _styledComponents.css)(["background:", ";cursor:default;border-top-color:", ";color:", ";"], (0, _helpers.color)('neutral-4'), (0, _helpers.color)('brand'), (0, _helpers.color)('white'));
var CurrentMenuItem = (0, _styledComponents.default)(BaseComponent).withConfig({
  displayName: "CurrentMenuItem",
  componentId: "sc-1pt5s69-6"
})(["&&,&&:hover,&&:focus,&&:active{", " opacity:1;}"], currentCss);
var loadingCss = (0, _styledComponents.css)(["color:transparent;cursor:default;"]);
var LoadingMenuItem = (0, _styledComponents.default)(BaseComponent).withConfig({
  displayName: "LoadingMenuItem",
  componentId: "sc-1pt5s69-7"
})(["&&,&&:hover,&&:focus,&&:active{", "}"], loadingCss);
var disabledCss = (0, _styledComponents.css)(["background:", ";cursor:default;color:", ";"], (0, _helpers.color)('statusDisabled'), (0, _helpers.color)('dark-1'));
var DisabledMenuItem = (0, _styledComponents.default)(BaseComponent).withConfig({
  displayName: "DisabledMenuItem",
  componentId: "sc-1pt5s69-8"
})(["&&,&&:hover,&&:focus,&&:active{", "}"], disabledCss);

var disabledOnClick = function disabledOnClick(e) {
  return e.preventDefault();
};

var MenuItemSwitcher = function MenuItemSwitcher(_ref2) {
  var loading = _ref2.loading,
      current = _ref2.current,
      disabled = _ref2.disabled,
      props = _objectWithoutProperties(_ref2, ["loading", "current", "disabled"]);

  switch (true) {
    case loading:
      {
        return _react.default.createElement(LoadingMenuItem, props);
      }

    case current:
      {
        return _react.default.createElement(CurrentMenuItem, props);
      }

    case disabled:
      {
        return _react.default.createElement(DisabledMenuItem, _extends({
          onClick: disabledOnClick
        }, props, {
          to: ""
        }));
      }

    default:
      {
        return _react.default.createElement(DefaultMenuItem, props);
      }
  }
};

var DesktopMenuItem = (0, _styledComponents.default)(MenuItemSwitcher).withConfig({
  displayName: "DesktopMenuItem",
  componentId: "sc-1pt5s69-9"
})([""]);
var _default = DesktopMenuItem;
exports.default = _default;